/**
 * Order Shipping Loading Zones service
 *
 * @version
 * 4.71.0 OAUI-693 Tidy and remove duplicated code
 * 4.71.0 OAUI-684 Improve shared code and add interfaces
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.52.0 OAUI-601 Add shipping/truck loading zone field into order details
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WdLocalSharedFunctionsService } from '../../../shared/wd-local-shared-functions.service';
import { ILoadingZoneApiModel } from '../../../../interfaces/orders/order-interfaces';

@Injectable({
  providedIn: 'root',
})
export class WdOrderShippingLoadingZonesService {
  isLoading = new BehaviorSubject(false);

  // Options
  loadingZoneOptions = new BehaviorSubject<Array<ILoadingZoneApiModel>>([]);

  /**
   * Constructor
   *
   * @since 4.52.0
   */
  constructor(
    private wdLocalSharedFunctions: WdLocalSharedFunctionsService,
    @Inject('wdErrorService') public wdErrorService: any,
    @Inject('wdOauth2HttpService') public wdOauth2HttpService: any,
    @Inject('wdSharedFunctionsService') public wdSharedFunctionsService: any,
  ) {}

  /**
   * GET shipping loading zone options
   *
   * @since 4.52.0
   */
  async getLoadingZoneOptions(): Promise<void> {
    // Toggle Loader
    this.isLoading.next(true);
    try {
      const response = await this.wdOauth2HttpService.get(
        `${this.wdLocalSharedFunctions.manufacturingAdminApiUrl}orders/shipping/loadingZones`,
      );
      const options = response.data;
      this.loadingZoneOptions.next(options);
    } catch (error) {
      this.wdErrorService.userError(
        'Error',
        `Error getting loading zone options`,
      );
      throw error;
    } finally {
      // Toggle Loader
      this.isLoading.next(false);
    }
  }
}
